import React, { useState } from "react";
import { settings } from "../data/settings";

export const uploadImageToServer = async (base64Image, fileName, storagePath) => {
  try {
    const response = await fetch(`${settings.websiteName + settings.scriptsDir}uploadImage.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        fileName,
        storagePath: `${storagePath}/images/`,
        base64Image
      })
    });

    const result = await response.json();
    if (result.status === "success") {
      console.log("✅ Image enregistrée :", result.url);
      return result.url;
    } else {
      throw new Error(result.message || "Erreur serveur");
    }
  } catch (error) {
    console.error("❌ Erreur d'upload :", error);
    return null;
  }
};

export const compressBase64Image = (base64, quality = 0.7, resizeIfTooBig = true) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      let width = img.width;
      let height = img.height;

      const maxWidth = 1000;
      if (resizeIfTooBig && width > maxWidth) {
        width = maxWidth;
        height = (img.height / img.width) * maxWidth;
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      const format = base64.includes("image/png") ? "image/png" : "image/webp";
      resolve(canvas.toDataURL(format, resizeIfTooBig ? quality : 1.0));
    };
  });
};

const ImageUploader = ({ 
  fileSelected, setFileSelected,
  imageUrl,
  uploadToServer, setUploadToServer,
  resizeIfTooBig, setResizeIfTooBig }) => {

  const [preview, setPreview] = useState(imageUrl);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileSelected(file);
      /*const fileReader = new FileReader();
      fileReader.onload = async () => {
        const compressedImage = await compressBase64Image(
          fileReader.result,
          0.8,
          resizeIfTooBig
        );
        setPreview(compressedImage);

        console.log("resizeIfTooBig :", resizeIfTooBig);
        console.log("uploadToServer :", uploadToServer);

        if (uploadToServer) {
          const fileName = file.name.replace(/\.[^/.]+$/, "") + ".webp";
          const storagePath = settings.storageDirFromScript;
          const imageUrl = await uploadImageToServer(
            compressedImage,
            fileName,
            storagePath
          );
          onUpload(settings.websiteName + settings.scriptsDir + imageUrl);
          console.log("Image uploaded to server:", imageUrl);
        } else {
          onUpload(compressedImage);
          console.log("Image not uploaded to server, using local base64.");
        }
      };
      fileReader.readAsDataURL(file);

      */
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      {preview && (
        <img src={preview} alt="Aperçu" style={{ maxWidth: "100px" }} />
      )}
      <input type="file" accept="image/*" onChange={handleFileChange} />
      <label>
        <input
          type="checkbox"
          checked={uploadToServer}
          onChange={(e) => setUploadToServer(e.target.checked)}
        />
        Fichier externe ?
      </label>
      <label>
        <input
          type="checkbox"
          checked={resizeIfTooBig}
          onChange={(e) => setResizeIfTooBig(e.target.checked)}
        />
        Réduire la taille ?
      </label>
    </div>
  );
};

export default ImageUploader;
